import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import FormField from './FormField';
import { injectStripe } from 'react-stripe-elements';
import DropdownField from 'components/forms/DropdownField';
import PaymentMethodFieldset from './fieldsets/PaymentMethodFieldset';
import styles from './CheckoutForm.scss';

class CheckoutForm extends Component {
  static propTypes = {
    availableCountries: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    packageTemplateSet: ImmutablePropTypes.map.isRequired,
    isRebooking: PropTypes.bool,
  }

  render() {
    const {
      formErrors,
      isLoading,
      packageTemplateSet,
      isRebooking
    } = this.props;

    return (
      <Form className={styles.checkout}>
        <fieldset disabled={isLoading}>
          <FormField
            label="Name for the Invoice / Receipt"
            error={formErrors.get('business_name')}
            name="business_name"
            component="input"
            type="text"
            className="form-control"
            placeholder="Business Name"
            autoComplete="business_name"
            required
          />
          <FormField
            label="Address Line 1"
            error={formErrors.get('address1')}
            name="address1"
            component="input"
            type="text"
            className="form-control"
            placeholder="Address Line 1"
            required
          />
          <FormField
            label="Address Line 2"
            error={formErrors.get('address2')}
            name="address2"
            component="input"
            type="text"
            className="form-control"
            placeholder="Address Line 2"
          />
          <div className="row">
            <div className="col-sm-6">
              <FormField
                label="Town / City"
                error={formErrors.get('city')}
                name="city"
                component="input"
                type="text"
                className="form-control"
                placeholder="Town Name"
                required
              />
            </div>
            <div className="col-sm-6">
              <FormField
                label="State / Region"
                error={formErrors.get('state')}
                name="state"
                component="input"
                type="text"
                className="form-control"
                placeholder="State Name"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <FormField
                label="Zip Code / Post Code"
                error={formErrors.get('zip_code')}
                name="zip_code"
                component="input"
                type="text"
                className="form-control"
                placeholder="Your Zip Code"
                required
              />
            </div>
            <div className="col-sm-6">
              <FormField
                label="Country"
                error={formErrors.get('country')}
                name="country"
                component={DropdownField}
                inputProps={{ valueField: 'iso_alpha2', textField: 'name' }}
                data={this.props.availableCountries.toJS()}
                type="text"
                className="form-control"
                placeholder="Select a Country"
                required
              />
            </div>
          </div>
          <hr/>
          <PaymentMethodFieldset
            formErrors={formErrors}
            isRebooking={isRebooking}
            selectorEnabled={packageTemplateSet.get('bank_payment_available', false)}
            bankPaymentAvailable={packageTemplateSet.get('bank_payment_available', false)}
          />
        </fieldset>
      </Form>
    );
  }
}

export default injectStripe(reduxForm({
  form: 'address',
  destroyOnUnmount: false,
})(CheckoutForm), { withRef: true });



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/CheckoutForm.jsx